import { Customer_MarketingConsents } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import { UserEnumDTO } from 'features/shared/enums/dynamic/UserEnumDTO';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import IAppState from 'infrastructure/store/IAppState';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MarketingConsentsDialog from 'features/consents/components/MarketingConsentsDialog';
import MarketingConsentReactionDTO from 'features/consents/dtos/MarketingConsentReactionDTO';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import IRepository from 'data/IRepository';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import { trackPromise } from 'react-promise-tracker';
import { Dashboard_MarketingConsentsDialog } from 'features/shared/components/loaders/promiseLoadingAreas';
import { Dispatch } from 'redux';
import { MarketingConsentsAction, setClosedDialog } from 'infrastructure/store/marketingConsents/MarketingConsentsActions';
import MarketingConsentsState from 'infrastructure/store/marketingConsents/MarketingConsentsState';

const MarketingConsentsSection = () => {
  // DI
  const consentRepository = useInjection<IRepository<MarketingConsentReactionDTO[]>>(IocTypes.Repository);

  // store
  const customer = useSelector<IAppState, CustomerState>((store) => store.customer).customer;
  const state = useSelector<IAppState, MarketingConsentsState>((store) => (store as any).marketingConsents);
  const consentsDispatch = useDispatch<Dispatch<MarketingConsentsAction>>();

  const isClosedForCustomer = !!state?.closedByCustomerId?.[customer.customerId!];

  const { data, loadStatus } = useQuery<UserEnumDTO[]>(
    {
      url: Customer_MarketingConsents,
      routeParams: getRouteParams('customerId', customer.customerId!)
    },
    [],
    [customer.customerId],
    { useTracker: false },
    { apply: true, condition: () => !isClosedForCustomer }
  );

  const hasPending = Array.isArray(data) && data.length > 0;
  const shouldShowDialog = hasPending && !isClosedForCustomer;

  // handlers
  const sendMarketingConsentsHandler = async (consents: MarketingConsentReactionDTO[]) => {
    await trackPromise(
      consentRepository.post({
        url: Customer_MarketingConsents,
        routeParams: getRouteParams('customerId', customer.customerId!),
        data: consents,
      }),
      Dashboard_MarketingConsentsDialog
    );
    consentsDispatch(setClosedDialog(customer.customerId!, true));
  };

  const closeDialogHandler = () => {
    consentsDispatch(setClosedDialog(customer.customerId!, true));
  };

  // render
  return (
    <NoContentWrapper
      data={data}
      loadStatus={loadStatus}
      noContentRender={() => <></>}
    >
      {shouldShowDialog && (
        <MarketingConsentsDialog
          key={customer.customerId}
          show={true}
          consentTypes={data}
          onSubmit={sendMarketingConsentsHandler}
          onClose={closeDialogHandler}
        />
      )}
    </NoContentWrapper>
  );
};

export default MarketingConsentsSection;